// src/pages/Login.js
import React, { useState } from 'react';
import { auth } from "../../config/firebaseConfig";
import { signInWithEmailAndPassword, sendPasswordResetEmail } from 'firebase/auth';
// import { Link } from 'react-router-dom';

function LoginModal({ setShowLoginModal, setShowSignupModal }) {

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const handleSignIn = (e) => {
    e.preventDefault();
    signInWithEmailAndPassword(auth, email, password)
    .then((userCredential) => {
      console.log(userCredential)
      window.location.href = '/';
    }).catch((error) => {
      console.log(error);
      alert(error)
    })
  }

  // New function to handle password reset
  const handleForgotPassword = () => {
    const email = prompt("Please enter your email address:");
    if (email) {
      sendPasswordResetEmail(auth, email)
        .then(() => {
          alert("Password reset email sent!");
        })
        .catch((error) => {
          console.error(error);
          alert("Error sending password reset email: " + error.message);
        });
    }
  }

  return (
    <div 
      className="modal-overlay" 
      style={{ position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', backgroundColor: 'rgba(0, 0, 0, 0.5)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 9999 }}
      onClick={() => setShowLoginModal(false)}
    >
      <div 
        className="modal p-4 sm:p-6 lg:p-8 overflow-auto max-h-full mx-4 sm:mx-0" 
        style={{ 
          cursor: 'default', 
          width: '95vw',
          maxWidth: '450px',
          minHeight: 'auto',
          maxHeight: '90vh',
          backgroundColor: 'white', 
          borderRadius: '10px'
        }}
        onClick={(e) => e.stopPropagation()} // Prevent click event from propagating to the overlay
      >
        {/* <div className="self-start mb-4">
          <button 
            onClick={() => window.location.href = 'http://www.withgrantmagic.com'} 
            className="w-30 h-12 p-2 bg-gray-200 hover:bg-gray-300 rounded"
          >
            Return Home
          </button>
        </div> */}

        <div className="sm:mx-auto sm:w-full sm:max-w-sm">
          <h3 className="mt-6 sm:mt-10 text-center text-xl sm:text-2xl font-bold leading-9 tracking-tight">
            Welcome back to GrantMagic!
          </h3>
          <h3 className="mt-2 text-center text-lg sm:text-xl leading-9 tracking-tight text-gray-500">
            How are you? We missed you.
          </h3>
        </div>

        <div className="mt-6 sm:mt-10 sm:mx-auto sm:w-full sm:max-w-sm">
          <form className="space-y-4 sm:space-y-6" action="#" method="POST" onSubmit={handleSignIn}>
            <div>
              <label htmlFor="email" className="block text-sm font-medium leading-6 text-left">
                Email Address
              </label>
              <div className="mt-2">
                <input
                  value={email}
                  id="email"
                  name="email"
                  type="email"
                  autoComplete="email"
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  className="block w-full rounded-md border-0 py-2 sm:py-1.5 pl-3 sm:pl-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 text-base sm:text-sm"
                />
              </div>
            </div>

            <div>
              <div className="flex items-center justify-between">
                <label htmlFor="password" className="block text-sm font-medium leading-6 text-left">
                  Password
                </label>
              </div>
              <div className="mt-2">
                <input
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  id="password"
                  name="password"
                  type="password"
                  autoComplete="current-password"
                  required
                  className="block w-full rounded-md border-0 py-2 sm:py-1.5 pl-3 sm:pl-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 text-base sm:text-sm"
                />
              </div>
            </div>

            <div>
              <button
                type="submit"
                className="flex w-full justify-center rounded-md bg-indigo-600 px-3 py-2 sm:py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
              >
                Sign In
              </button>
            </div>
          </form>

          {/* // New "Forgot Password" button */}
          <div className="mt-4">
            <button
              onClick={handleForgotPassword}
              className="text-sm font-semibold leading-6 text-gray-600 hover:text-gray-500"
            >
              Forgot Password?
            </button>
          </div>

          <p className="mt-6 sm:mt-10 text-center text-sm text-gray-500">
            Not a member?{' '}
            <button 
              className="font-semibold leading-6 text-indigo-600 hover:text-indigo-500"
              onClick={() => {
                setShowSignupModal(true);
                setShowLoginModal(false);
              }}
            >
              Sign up now.
            </button>
          </p>
        </div>
{/* 
        <div className='flex items-center justify-center mt-6'>
          <button 
            className="p-2 bg-gray-500 text-white rounded hover:bg-gray-600" 
            onClick={() => setShowLoginModal(false)}
          >
            Close
          </button>
        </div> */}
      </div>
    </div>
  );
}

export default LoginModal;